import { Component, Inject, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {}

@Component({
  selector: "uom-item-dialog",
  templateUrl: "uom-item-dialog.html",
})
export class UOMItemDialog implements AfterViewInit {
  constructor(
    public dialogRef: MatDialogRef<UOMItemDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {}

  ngAfterViewInit() {}
}
